 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_cover'
 import HTML01_TITLE from '@/components/html/01_title'
 import HTML02_COPYRIGHT from '@/components/html/02_copyright'
 import HTML03_DEDI from '@/components/html/03_dedi'
 import HTML04_PRO from '@/components/html/04_pro'
 import HTML05_LETTER from '@/components/html/05_letter'
 import HTML06_TOC from '@/components/html/06_toc'
 import HTML07_INTRO from '@/components/html/07_intro'
 import HTML08_CHAP1 from '@/components/html/08_chap1'
 import HTML09_CHAP2 from '@/components/html/09_chap2'
 import HTML10_CHAP3 from '@/components/html/10_chap3'
 import HTML11_CHAP4 from '@/components/html/11_chap4'
 import HTML12_CHAP5 from '@/components/html/12_chap5'
 import HTML13_CHAP6 from '@/components/html/13_chap6'
 import HTML14_CHAP7 from '@/components/html/14_chap7'
 import HTML15_CHAP8 from '@/components/html/15_chap8'
 import HTML16_CHAP9 from '@/components/html/16_chap9'
 import HTML17_CHAP10 from '@/components/html/17_chap10'
 import HTML18_REFERENCE from '@/components/html/18_reference'
 import HTML19_FINAL from '@/components/html/19_final'
 import HTML20_AUTHOR from '@/components/html/20_author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/00_cover",
 			"name" : "html/00_cover",
 			"component" : HTML00_COVER
 		},
 		{
 			"path" : "/html/01_title",
 			"name" : "html/01_title",
 			"component" : HTML01_TITLE
 		},
 		{
 			"path" : "/html/02_copyright",
 			"name" : "html/02_copyright",
 			"component" : HTML02_COPYRIGHT
 		},
 		{
 			"path" : "/html/03_dedi",
 			"name" : "html/03_dedi",
 			"component" : HTML03_DEDI
 		},
 		{
 			"path" : "/html/04_pro",
 			"name" : "html/04_pro",
 			"component" : HTML04_PRO
 		},
 		{
 			"path" : "/html/05_letter",
 			"name" : "html/05_letter",
 			"component" : HTML05_LETTER
 		},
 		{
 			"path" : "/html/06_toc",
 			"name" : "html/06_toc",
 			"component" : HTML06_TOC
 		},
 		{
 			"path" : "/html/07_intro",
 			"name" : "html/07_intro",
 			"component" : HTML07_INTRO
 		},
 		{
 			"path" : "/html/08_chap1",
 			"name" : "html/08_chap1",
 			"component" : HTML08_CHAP1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js